<template>
  <div class="container">
    <div class="home-banner">
      <img class="banner-bg" src="@/assets/guanyuwomen.png" alt="">
      <div class="textBox typeArea">
        <p class="centerBanner animated zoomIn">关于我们</p>
      </div>
    </div>
    <div class="gymw">
      <div class="gy-box">
        <div class="gy-cont">
          <div style="padding-bottom: 80px;"></div>
          <div class="common-title">
            部盾介绍
          </div>
          <div class="gy-text">
            <p>部盾信息科技有限公司致力于大数据在管理及业务决策中的应用：使用机构和企业数据，对实体运行进行数字化还原、模拟和预测，运用集成化的决策分析和建模技术，为政策和业务决策人员提供指向明确的诊断和决策依据、实施路径和执行抓手。 </p>
            <p>部盾的核心人员以大数据在管理和业务决策中的应用，即数字化转型为职业生涯；均拥有20多年从事将传统IT业务转型为数字化管理业务的经验，尤其是在成功实现从数据服务公司转型为数字化解决方案服务公司的工作经历。</p>
            <p>经过多年的努力，部盾团队在管理与业务决策领域将成熟的大数据分析与数字化决策产品集成为现有系统，核心产品是在业务记录数据的基础上，直接搭建基于数据分析、建模、预测和决策指向技术的诊断报告和业务看板系统。
            <p>与单纯的可视化产品和传统BI产品的区别在于：决策指向产品是围绕决策主题、决策责任和岗位职能生成诊断性和指向性的结论；对任何诊断和指向性的结论，做到可解释、可深挖、可追溯。</p>
            <p>部盾产品产生的决策信息，服务于从行业监管、企业战略决策、日常管理和业务决策中的各个层面和环节。从基础数据到数字化决策信息的产生和推送过程，实现了快捷、便利、四通八达。 </p>
          </div>
          <div style="padding-bottom: 80px;"></div>
        </div>
      </div>
      <div class="gy-box gy-ry" style="height: 431px;">
        <div class="gy-cont">
          <div style="padding-bottom: 80px;"></div>
          <div class="common-title">
            企业荣誉
          </div>
          <div class="gy-table">
            <div class="table-line" style="background: rgba(0, 0, 0, 0);">
              <div class="table-left">所获专利名称</div>
              <div class="table-center">专利号</div>
              <div class="table-right">所属国家</div>
              <div style="clear: both;"></div>
            </div>
            <div class="table-line">
              <div class="table-left">对工业批产型大数据进行多级递进建模的方法及系统</div>
              <div class="table-center">202010779095.7</div>
              <div class="table-right">中国</div>
              <div style="clear: both;"></div>

            </div>
            <div class="table-line">
              <div class="table-left">事件预测及因子识别动态模拟模型建模方法及系统</div>
              <div class="table-center">202010779604.6</div>
              <div class="table-right">中国</div>
              <div style="clear: both;"></div>

            </div>
            <div class="table-line">
              <div class="table-left">Multiple Time-Dimension Simulation Models and Lifecycle Dynamic Scoring System</div>
              <div class="table-center">15/878411</div>
              <div class="table-right">美国</div>
              <div style="clear: both;"></div>

            </div>
          </div>
          <div style="padding-bottom: 80px;"></div>
        </div>
      </div>
      <div class="gy-box" style="height: 756px;">
        <div class="gy-cont">
          <div style="padding-bottom: 58px;"></div>
          <div class="gy-zhuanzhu">
            <div class="zhuanzhu-title">专著</div>
            <div class="zhuanzhu-text">有关生命周期动态模拟(DSS)的45万字著述</div>
            <div class="zhuanzhu-img"><img src="@/assets/zhuanzhu.png" alt=""></div>
          </div>
          <div style="padding-bottom: 80px;"></div>
        </div>
      </div>
      <div class="gy-box tuandui">
        <div class="gy-cont">
          <div style="padding-bottom: 80px;"></div>
          <div class="common-title">
            团队介绍
          </div>
          <div class="tuandui-list">
            <ul>
              <li>
                <div class="tuandui-list-name">
                  <div class="name-max">
                    部瑞志 
                  </div>
                  <div class="name-min">
                    CEO
                  </div>
                  <div style="clear:both;"></div>
                </div>
                <div class="tuandui-line"></div>
                <div class="tuandui-text">
                  部瑞志，1985年本科毕业于南京大学天体物理学专业，1988年研究生毕业于南京大学经济计量学专业，1995年在芝加哥伊利诺伊大学获得经济学博士学位。任职经历包括：1988-1989年在中国社会科学院任助理研究员；1995 -2001年在伊利诺伊工具公司的宾克斯公司任中国区域经理；2001-2006年在汇丰银行北美公司工作，担任过信用风险管理部门的高级经理、消费信贷信用风险管理部门的经理、消费贷款组合部门的高级分析师；2006-2010年在富国金融风险管理部任损失预测与储备主管；2010年10月至2017年6月在标准普尔前100强公司阿格斯信息和咨询服务公司担任高级副总裁和预测首席科学家；
                </div>
              </li>
              <li>
                <div class="tuandui-list-name">
                  <div class="name-max">
                    彭媛媛  
                  </div>
                  <div class="name-min">
                    首席建模专家
                  </div>
                  <div style="clear:both;"></div>
                </div>
                <div class="tuandui-line"></div>
                <div class="tuandui-text">
                  彭媛媛，2001年本科毕业于复旦大学世界经济学专业，2007年在佛罗里达国际大学获得经济学博士学位，博士的主演研究方向为产业组织和应用计量经济学。2007年10月—2013年11月，彭博士就职于Affinion集团，任市场分析与建模高级统计师；2013年11月至今，在阿格斯信息和咨询服务公司担任战略分析高级经理。
                </div>
              </li>
              <li>
                <div class="tuandui-list-name">
                  <div class="name-max">
                    崔豫平  
                  </div>
                  <div class="name-min">
                    CTO
                  </div>
                  <div style="clear:both;"></div>
                </div>
                <div class="tuandui-line"></div>
                <div class="tuandui-text">
                  崔豫平，拥有20年以上软件开发、架构和部署经验。1986年在北京大学获得数学学士学位，1991年在俄亥俄州立大学获得数学硕士学位，1995年在俄亥俄州立大学获得数学博士学位。1995年4月—2000年3月任职于朗讯科技公司，在硬件、操作系统和编程方面获得了丰富的工作经验；2005年6月—2007年9月在雷曼兄弟的一个团队任副总裁；2007年9月—2010年4月在汇丰银行结构性信贷产品团队任副总裁；2010年4月—2011年9月在JP摩根外汇期权交易中前台任副总裁；2011年9月—2016年7月在野村证券证券化产品部门任副总裁。
                </div>
              </li>
              <li>
                <div class="tuandui-list-name">
                  <div class="name-max">
                    杜勇   
                  </div>
                  <div class="name-min">
                    首席数据专家
                  </div>
                  <div style="clear:both;"></div>
                </div>
                <div class="tuandui-line"></div>
                <div class="tuandui-text">
                  杜勇，本科毕业于北京大学数学系，主修概率统计方向；数学硕士学位在俄亥俄州立大学获得。1997-2001年在朗讯科技公司无线部门担任高级java开发者；2003—2007年在俄亥俄卫生部担任高级软件工程师；2010年2月至今在JP摩根全球身份和访问管理部门担任副总裁和应用工程师。
                </div>
              </li>
              <div style="clear:both;"></div>
            </ul>
          </div>
          <div style="padding-bottom: 80px;"></div>
        </div>
      </div>
      <div class="gy-box">
        <div class="gy-cont">
          <div style="padding-bottom: 148px;"></div>
          <div class="common-title">
            企业文化
          </div>
          <div style="padding-bottom: 80px;"></div>
          <div class="gy-hexin">
            <ul>
              <li class=" hexin-bg1">
                <div class="hexin-box">
                  <div class="hexin-tit">
                    使命 
                  </div>
                  <div class="hexin-text">
                    通过数据分析，让数据服务于企业，让企业决策更加精准
                  </div>
                </div>
              </li>
              <li class="hexin-bg2">
                <img src="@/assets/1.png" alt="">
              </li>
              <li class=" hexin-bg3">
                <div class="hexin-box">
                  <div class="hexin-tit">
                    价值观
                  </div>
                  <div class="hexin-text">
                    诚实守信契约精神团队精神成就客户勇于创新
                  </div>
                </div>
              </li>
              <li class=" hexin-bg4"><img src="@/assets/2.png" alt=""></li>
              <li class=" hexin-bg5">
                <div class="hexin-box ">
                  <div class="hexin-tit">
                    愿景
                  </div>
                  <div class="hexin-text">
                    成为全球企业的数据决策供应企业
                  </div>
                </div>
              </li>
              <li class=" hexin-bg6"><img src="@/assets/3.png" alt=""></li>
              <div style="clear: both;"></div>
            </ul>
          </div>
          <div style="padding-bottom: 80px;"></div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: "AboutUs",
  data() {
    return {
    };
  },
  methods: {
      
  },
  mounted() {

  },
}
</script>

<style scoped>
   
</style>